export default "__VITE_ASSET__BR7lb66A__"